// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3ZwgV","colMaxWidth":"Table_colMaxWidth__bfX9D"};